var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIcReset(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.36634 6.34999C7.99634 4.71999 10.3063 3.77999 12.8463 4.03999C16.5163 4.40999 19.5363 7.38999 19.9463 11.06C20.4963 15.91 16.7463 20 12.0163 20C8.82634 20 6.08634 18.13 4.80634 15.44C4.48634 14.77 4.96634 14 5.70634 14C6.07634 14 6.42634 14.2 6.58634 14.53C7.71634 16.96 10.4263 18.5 13.3863 17.84C15.6063 17.35 17.3963 15.54 17.8663 13.32C18.7063 9.43999 15.7563 5.99999 12.0163 5.99999C10.3563 5.99999 8.87634 6.68999 7.79634 7.77999L9.30634 9.28999C9.93634 9.91999 9.49634 11 8.60634 11H5.01634C4.46634 11 4.01634 10.55 4.01634 9.99999V6.40999C4.01634 5.51999 5.09634 5.06999 5.72634 5.69999L6.36634 6.34999Z",
    fill: "#565A5E"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcReset);
export default __webpack_public_path__ + "static/media/ic-reset.f7b3437e56571a6b60838dfb1c303147.svg";
export { ForwardRef as ReactComponent };